import { toast } from 'sonner';

/**
 * The toasts of the onboarding buddy (KAN-1771), each with a fixed id: there
 * is at most one success and one hint on screen, and a new success updates
 * the toast that stands instead of stacking a second one.
 */
/**
 * The buddy's toasts have a Sonner list of their own: they move aside for the
 * share popover (``use-toast-clear-of-popover``), and in the common list a plain
 * toast behind them would stay put as an empty box, over the popover's heading.
 */
export const BUDDY_TOASTER_ID = 'onboarding-buddy';

export const CELEBRATION_TOAST_ID = 'onboarding-celebration';
export const TIP_TOAST_ID = 'onboarding-tip';
/** The goodbye where the buddy cannot say it itself; it stays when the next message goes out. */
export const FAREWELL_TOAST_ID = 'onboarding-farewell';

/** Takes the buddy's toasts away: the next message went out, or the workspace changed. */
export function dismissOnboardingToasts(): void {
  toast.dismiss(CELEBRATION_TOAST_ID);
  toast.dismiss(TIP_TOAST_ID);
}
